<div class="ai-pointer-events-blocker">
  <ng-template #dynamicHost></ng-template>
</div>
@if(showRelatedPathCta){
  <div>
    <button [state]="{ myData: dataToSend }" [routerLink]="relatedPathCtaLink"  [fragment]="relatedFragment">
      Jump to the corresponding page
    </button>
  </div>
}

